import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import { IconEye, IconEyeOff } from '@tabler/icons-react'

import './styles/form.css'

function FormLogin() {

    const [ tooglePassword, setTooglePassword ] = useState(false);

    const handleSubmitLogin = (e) => {
        e.preventDefault();
        alert('Please enter your password');
    }

    return (

        <form className='--form-login' method='POST' onSubmit={handleSubmitLogin}>

            <div className='--form-group'>

                <label htmlFor='entryEmail' className='--label-form-lgn'>Email o correo electrónico</label>

                <div className='--form-control'>
                    <input type='email' className='--entry-form-lgn' name='entryEmail' id='entryEmail' placeholder='Ingresa tu Email o correo electrónico' aria-placeholder='Ingresa tu Email o correo electrónico' autoComplete='off' />
                </div>

            </div>

            <div className='--form-group'>

                <label htmlFor='entryPassword' className='--label-form-lgn'>Contraseña</label>

                <div className='--form-control'>
                    <input type={`${tooglePassword ? 'text' : 'password'}`} className='--entry-form-lgn --entry-form-lgn--password' name='entryPassword' id='entryPassword' placeholder='Ingresa tu contraseña' aria-placeholder='Ingresa tu contraseña' autoComplete='off' />
                    <span className='--ico-form-lgn' onClick={() => setTooglePassword(!tooglePassword)}>{tooglePassword ? <IconEye/> : <IconEyeOff/>}</span>
                </div>

                <Link to={'/recover'} className='--a-form-lgn'>¿Olvidaste tu contraseña?</Link>

            </div>

            <div className='--form-group'>
                <button className='--btn --btn-lgn'>Ingresar</button>
            </div>

            <div className='--form-group'>
                <p className='--span-form-lgn'>¿Aún no tienes una cuenta?. <Link to={'/sign'}>Créalo aquí</Link></p>
            </div>

        </form>
    )

}

export default FormLogin